import { render, staticRenderFns } from "./Saga2Komunikace.vue?vue&type=template&id=08bb05b4&"
import script from "./Saga2Komunikace.vue?vue&type=script&lang=ts&"
export * from "./Saga2Komunikace.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports